import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appComponentLoader]',
  standalone: true,
})
export class ComponentLoaderDirective {
  constructor(readonly viewContainerRef: ViewContainerRef) {}
}
